module.exports = __webpack_public_path__ + "static/banner.29f9dc65.png";